import BasePopup from "../../../../src/scripts/classes/BasePopup";

var PopupItem = function(options) {
	// Call parent constructor
	BasePopup.call(this, $.extend(true, {
		baseClass: 'el-PopupItem',
		dotSelector: '.popup-item_icon-wrapper',
		popupSelector: '.popup-item_wrapper',
		pointerSelector: '.popup-item_pointer',
		componentName: 'PopupItem'
	}, options));
};

// Inherit from BasePopup
PopupItem.prototype = Object.create(BasePopup.prototype);
PopupItem.prototype.constructor = PopupItem;

export default PopupItem;

